import React from "react";
import styles from "./ResetFilter.module.scss";
import {close} from "assets/images";

const ResetFilter = ({ filtrar, onClick, setZoom }) => {
    return (
        <div
            className={styles.boxResetCategory}
            onClick={() => {
                filtrar(null);
                if (onClick) {
                    onClick();
                };
            }}
        >
            <img src={close} className={styles.btnReset} alt="Limpar filtro"/>           
        </div>
    )
};
export default ResetFilter;